import { render, staticRenderFns } from "./GranissatHeadlinePane.vue?vue&type=template&id=f408a7f2&"
import script from "./GranissatHeadlinePane.vue?vue&type=script&lang=js&"
export * from "./GranissatHeadlinePane.vue?vue&type=script&lang=js&"
import style0 from "./GranissatHeadlinePane.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports